import { render, staticRenderFns } from "./CovsDetail.vue?vue&type=template&id=af337fca&scoped=true"
import script from "./CovsDetail.vue?vue&type=script&lang=js"
export * from "./CovsDetail.vue?vue&type=script&lang=js"
import style0 from "./CovsDetail.vue?vue&type=style&index=0&id=af337fca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af337fca",
  null
  
)

export default component.exports